module.exports = __webpack_public_path__ + "img/RamsayWilliam.6d6a60a2.jpg";